var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"divider"}),_c('div',{ref:"chartRef",staticClass:"chart"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }